import { useSyncExternalStore } from 'react';

/**
 * État de la connexion, tel que le navigateur le voit.
 *
 * `navigator.onLine` n'est qu'une indication : il dit qu'une interface réseau
 * existe, pas que le serveur répond. C'est suffisant pour ce qu'on en fait —
 * prévenir tôt — mais pas pour conclure : une requête qui échoue reste la seule
 * preuve d'une panne, et c'est elle qui porte le message définitif.
 */
function sAbonner(rappel: () => void): () => void {
  window.addEventListener('online', rappel);
  window.addEventListener('offline', rappel);
  return () => {
    window.removeEventListener('online', rappel);
    window.removeEventListener('offline', rappel);
  };
}

function instantane(): boolean {
  return navigator.onLine;
}

/* Le rendu serveur n'existe pas ici, mais `useSyncExternalStore` exige la
 * fonction : hors navigateur, on suppose la connexion présente plutôt que
 * d'afficher un bandeau d'alerte sur une page qui n'a encore rien tenté. */
function instantaneServeur(): boolean {
  return true;
}

export function useEnLigne(): boolean {
  return useSyncExternalStore(sAbonner, instantane, instantaneServeur);
}
